module.exports = __webpack_public_path__ + "static/media/community-gardens-gallery-9.8ae62882.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/community-gardens-gallery-9.jpg
// module id = 617
// module chunks = 11